import actions from './actions';
import types from './mutation-types';

const state = {
	item: {
		paid: 0
	},
	pendingBids: {
		data: [],
		meta: {
			currentPage: 1,
			total: null,
			totalPages: null
		},
	},
	lastCreatedItem: {},
	fetchError: {},
	formError: false,
	isFetching: false,
	isUploading: false,
	mediaError: false,
	isDeleting: false,
	isDeleted: false,
};

const getters = {
	item: state => state.item,
	lastCreatedItem: state => state.lastCreatedItem,
	pendingBids: state => state.pendingBids,
	isFetching: state => state.isFetching,
	formError: state => state.formError,
	isUploading: state => state.isUploading,
	mediaError: state => state.mediaError,
	isDeleting: state => state.isDeleting,
	isDeleted: state => state.isDeleted,
};

const mutations = {
	[types.RESET_ALL]() {
		state.item = {};
		state.formError = false;
		state.mediaError = false;
		state.fetchError = false;
		state.autocomplete = {
			category: {
				isFetching: false,
				data: [],
				error: null
			}
		};
	},
	[types.RESET_LAST_CREATED_ITEM]() {
		state.lastCreatedItem = {};
	},
	[types.FETCH_ITEM_START]() {
		state.isFetching = true;
	},
	[types.FETCH_ITEM](state, item) {
		state.item = item;
		state.isFetching = false;
	},
	[types.FETCH_ITEM_ERROR](state, error) {
		state.fetchError = error;
		state.isFetching = false;
	},
	[types.FETCH_PENDING_BIDS_START]() {
		state.isFetching = true;
	},
	[types.FETCH_PENDING_BIDS](state, pendingBids) {
		state.pendingBids = pendingBids;
		state.isFetching = false;
	},
	[types.FETCH_PENDING_BIDS_ERROR](state, error) {
		state.fetchError = error;
		state.isFetching = false;
	},
	[types.LAST_CREATED_ITEM](state, item) {
		state.lastCreatedItem = item;
	},
	[types.MOVE_ITEM_START](state) {
		state.isFetching = true;
	},
	[types.MOVE_ITEM](state, item) {
		state.item = item;
		state.isFetching = false;
		state.formError = false;
	},
	[types.MOVE_ITEM_ERROR](state, error) {
		state.formError = error.response.data;
		state.isFetching = false;
	},
	[types.UPDATE_ITEM_START]() {
		state.isFetching = true;
	},
	[types.UPDATE_ITEM](state, item) {
		state.item = item;
		state.isFetching = false;
		state.formError = false;
	},
	[types.UPDATE_ITEM_ERROR](state, error) {
		state.formError = error.response.data;
		state.isFetching = false;
	},
	[types.UPLOAD_MEDIA_START]() {
		state.isUploading = true;
		state.mediaError = false;
	},
	[types.UPLOAD_MEDIA](state, media) {
		state.item.media.push(media);
		state.isUploading = false;
		state.mediaError = false;
	},
	[types.UPLOAD_MEDIA_ERROR](state, error) {
		state.mediaError = error.response.data;
		state.isUploading = false;
	},
	[types.DELETE_MEDIA_START]() {
		state.isDeleting = true;
		state.mediaError = false;
		state.isDeleted = false;
	},
	[types.DELETE_MEDIA_SUCCESS](state, mediaKey) {
		state.item.media.splice(mediaKey, 1);
		state.isDeleting = false;
		state.mediaError = false;
		state.isDeleted = true;
	},
	[types.DELETE_MEDIA_ERROR](state, error) {
		state.mediaError = error.response.data;
		state.isDeleting = false;
		state.isDeleted = false;
	},
	[types.UPDATE_SELLER](state, seller) {
		state.item.seller = seller;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/item/index.js